/* Block - Events.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-events.scss";
import Swiper from "swiper/bundle"

 jQuery(document).ready(function(){
    const swiper = new Swiper('.rs-carousel', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      slidesPerGroup: 1,
      allowTouchMove: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: 'bullets',
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: ".swiper-next-prev__next",
        prevEl: ".swiper-next-prev__prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
          slidesPerGroup: 3,
        },
      },
    });
});
